var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',{attrs:{"label":"Bilder Rotation","inset":""},model:{value:(_vm.picRotation),callback:function ($$v) {_vm.picRotation=$$v},expression:"picRotation"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }